export function personTagTarget({ candidateId, employeeId, userId } = {}) {
  const type = Number(candidateId) > 0 ? 'candidate' : Number(employeeId) > 0 ? 'employee' : 'user';
  const id = Number(type === 'candidate' ? candidateId : type === 'employee' ? employeeId : userId);
  return Number.isSafeInteger(id) && id > 0 ? { type, id } : null;
}
export const tagPersonKey = target => target ? `${target.type}:${target.id}` : '';
export const normalizedTagName = value => String(value || '').trim().replace(/\s+/gu, ' ').toLocaleLowerCase();
export function tagTextColor(color) {
  const hex = /^#[a-f\d]{6}$/i.test(color || '') ? color.slice(1) : '64748B';
  const channels = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16) / 255).map(v => v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4);
  const luminance = channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722;
  // Keep small tag labels at 4.5:1, including custom colors near the contrast crossover.
  if (1.05 / (luminance + .05) >= 4.5) return '#FFFFFF';
  const darkContrast = (luminance + .05) / (.0091892193 + .05); // #111827
  return darkContrast >= 4.5 ? '#111827' : '#000000';
}
export function tagSelectionState(tagId, people) {
  const count = people.filter(person => person.tags?.includes(tagId)).length;
  return count === 0 ? 'none' : count === people.length ? 'all' : 'some';
}
export function tagAudienceLabel(tag, roles = []) {
  if (tag.visibility === 'super_admin') return 'Super admins only';
  if (tag.visibility === 'roles') return `Selected roles${roles.length ? ': ' + roles.filter(role => tag.role_ids?.includes(role.id)).map(role => role.name).join(', ') : ''}`;
  return 'All roles';
}

export const isTaggableCandidate = row => !!row?.id && row.status !== 'hired' && !row.is_deleted && !row.deleted_at;
